import { Injectable } from '@angular/core';
import { Store, createStore, withProps, select } from '@ngneat/elf';
import { Observable } from 'rxjs';

import { AddressLookupPrepop } from '@digital-platform/rs-addresses/domain';

@Injectable({
  providedIn: 'root',
})
export class AddressLookupPrepopService {
  addressLookupPrepopStore: Store = createStore(
    { name: 'addressLookupPrepop' },
    withProps<AddressLookupPrepop>(undefined as unknown as AddressLookupPrepop)
  );

  public addressLookupPrepop$: Observable<AddressLookupPrepop> =
    this.addressLookupPrepopStore.pipe(
      select((state) => state.addressLookupPrepop)
    );

  public setAddressLookupPrepop(
    addressLookupPrepop: AddressLookupPrepop | undefined
  ) {
    this.addressLookupPrepopStore.update(() => ({ addressLookupPrepop }));
  }
}
